import styled from 'styled-components';

export const SimulatorBar = styled.div`
    & i {
        font-size: 20px;
    }
`;

export const SimulatorButton = styled.button`
    padding: 20px !important;
    height: 75px;
    
    &.disabled {
        cursor: inherit !important;
        opacity: 0.5;
    }
    &:hover.disabled {
        background: #16a903 !important;
    }
`;

const Icon = styled.div`
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 30px;
    height: 30px;
`;

export const RotateIcon = styled(Icon)`
    background-image: url('/simulator/icon-robot-rotate-right.svg');
`;

export const PlayIcon = styled(Icon)`
    background-image: url('/simulator/icon-robot-play.svg');
`;

export const PauseIcon = styled(Icon)`
    background-image: url('/simulator/icon-robot-pause.svg');
`;

export const PowerOffIcon = styled(Icon)`
    background-image: url('/simulator/icon-robot-turn-off.svg');
`;

export const OzobotStart = styled(Icon)`
    background-image: url('/simulator/menu-01_${(props) => props.language}.svg'); 
    width: 150px;
    height: 150px;
    margin-top: -75px;
    cursor: pointer;
    
    &:hover {
        background-image: url('/simulator/menu-01_hover_${(props) => props.language}.svg');
    }
`;



// WEBPACK FOOTER //
// ./src/Simulator/SimulatorStyles.js